import { render, staticRenderFns } from "./SaveConfirmationModal.vue?vue&type=template&id=6184bfc2"
import script from "./SaveConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SaveConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports